import { ApplicantInterviewers } from './applicant-interviewers.model';

// This model is not resourceful and will only fetch data

export class MyInterviewers extends ApplicantInterviewers {
    protected static _resource = 'applicantTracker/myInterviews';
    // Don't want any data to be persisted to the backend.
    protected static _serializeAttributes = [];
}
